/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Green Sun', 'sticker name', 'web-stories');

function GreenSun({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 16.3335C21.1089 16.3335 16.3333 21.1091 16.3333 27.0002C16.3333 32.8912 21.1089 37.6668 27 37.6668C32.891 37.6668 37.6666 32.8912 37.6666 27.0002C37.6666 21.1091 32.891 16.3335 27 16.3335ZM14.3333 27.0002C14.3333 20.0046 20.0043 14.3335 27 14.3335C33.9956 14.3335 39.6666 20.0046 39.6666 27.0002C39.6666 33.9958 33.9956 39.6668 27 39.6668C20.0043 39.6668 14.3333 33.9958 14.3333 27.0002Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.8022 16.1357C20.9112 16.1357 16.1355 20.9114 16.1355 26.8024C16.1355 32.6934 20.9112 37.4691 26.8022 37.4691C32.6932 37.4691 37.4689 32.6934 37.4689 26.8024C37.4689 20.9114 32.6932 16.1357 26.8022 16.1357ZM14.1355 26.8024C14.1355 19.8068 19.8066 14.1357 26.8022 14.1357C33.7978 14.1357 39.4689 19.8068 39.4689 26.8024C39.4689 33.798 33.7978 39.4691 26.8022 39.4691C19.8066 39.4691 14.1355 33.798 14.1355 26.8024Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 0.333496C27.5523 0.333496 28 0.781211 28 1.3335V6.00016C28 6.55245 27.5523 7.00016 27 7.00016C26.4477 7.00016 26 6.55245 26 6.00016V1.3335C26 0.781211 26.4477 0.333496 27 0.333496Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27 47C27.5523 47 28 47.4477 28 48V52.6667C28 53.219 27.5523 53.6667 27 53.6667C26.4477 53.6667 26 53.219 26 52.6667V48C26 47.4477 26.4477 47 27 47Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.13936 8.14006C8.52988 7.74954 9.16305 7.74954 9.55357 8.14006L12.8669 11.4534C13.2574 11.8439 13.2574 12.4771 12.8669 12.8676C12.4764 13.2581 11.8432 13.2581 11.4527 12.8676L8.13936 9.55427C7.74884 9.16375 7.74884 8.53059 8.13936 8.14006Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1333 41.1327C41.5238 40.7422 42.1569 40.7422 42.5475 41.1327L45.8608 44.4461C46.2513 44.8366 46.2513 45.4698 45.8608 45.8603C45.4703 46.2508 44.8371 46.2508 44.4466 45.8603L41.1333 42.547C40.7427 42.1564 40.7427 41.5233 41.1333 41.1327Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.333282 27C0.333282 26.4477 0.780998 26 1.33328 26H5.99995C6.55223 26 6.99995 26.4477 6.99995 27C6.99995 27.5523 6.55223 28 5.99995 28H1.33328C0.780998 28 0.333282 27.5523 0.333282 27Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47 27C47 26.4477 47.4477 26 48 26H52.6667C53.219 26 53.6667 26.4477 53.6667 27C53.6667 27.5523 53.219 28 52.6667 28H48C47.4477 28 47 27.5523 47 27Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8669 41.1327C13.2574 41.5233 13.2574 42.1564 12.8669 42.547L9.55357 45.8603C9.16305 46.2508 8.52988 46.2508 8.13936 45.8603C7.74884 45.4698 7.74884 44.8366 8.13936 44.4461L11.4527 41.1327C11.8432 40.7422 12.4764 40.7422 12.8669 41.1327Z"
        fill="#235524"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.8608 8.14006C46.2513 8.53059 46.2513 9.16375 45.8608 9.55427L42.5475 12.8676C42.1569 13.2581 41.5238 13.2581 41.1333 12.8676C40.7427 12.4771 40.7427 11.8439 41.1333 11.4534L44.4466 8.14006C44.8371 7.74954 45.4703 7.74954 45.8608 8.14006Z"
        fill="#235524"
      />
    </svg>
  );
}

GreenSun.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 54 / 54,
  svg: GreenSun,
  title,
};
